import {AccountDetailDialogController} from './AccountDetailDialogController';
import { currencies, countries, subclients } from '../../../services/arsweb/RoutingPaths';
import {BackendService} from '../../../services/BackendService';
import {ConfirmationModalBean} from '../../../components/modal/ConfirmationModalBean';

export const ADDROUTE = 'administration.addAccount';
export const ADDTITLE = 'ADD_ACCOUNTS';
export const SUBCLIENTS = 'SUBCLIENTS';

/** @ngInject */
export class AddAccountController extends AccountDetailDialogController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies, "create");
        this.element = {description: ''};
        $scope.detailForm = {};
        this.formats = [{code: 'MT940'}, {code: 'BAI'}, {code: 'CAMT'}];

        //init curencues
        new BackendService(userService).getUserData(currencies).then((data) => { // currencies for account
            this.mainCurrencies = data.map(curr => {return {code: curr.code, description: curr.name};});
        });

        // init countries
        new BackendService(userService).getUserData(countries).then((data) => { // countries for account
            this.countries = data.map(country => {return {name: country.name, description: country.code};});
        });

        // init subclients
        this.subclientFilter = {value: this.SUBCLIENTS, kind: 'subclients', options: []};
        new BackendService(userService).getUserData(subclients).then((data) => {
            // subclients for account
            this.subclientFilter.options = data.map(element => {
               return {name: element, code: element, kind: 'subclients'};
            });
        });
     }

    create() {
        if(this.$scope.detailForm.$valid) {
            if(this.subclientFilter && this.subclientFilter.selectionList){
                this.element.subclients = this.subclientFilter.selectionList.map(el => el.code);
            }
            if(this.fieldsAreValid()) { // validate fields
                this.confirmAdd();
            }
        }else {
            this.infoPop('MISSING_MANDATORY');
        }
    }

    confirmAdd(){
        super.confirm(new ConfirmationModalBean(this.translate.instant('CONFIRMATION_ADD_ACCOUNT'),
            'ACCOUNTS', this.modal)).then((result) => {
            if(_.isNil(result)) {
                super.create();
            }
        });
    }

    fieldsAreValid() {
        let areValid = true;
        if(this.validateBIC()) {
            this.errorPop("BIC_IDENTIFICATION_VALID");
            areValid = false;
        }
        if((this.element.shortName && super.validateCharacters(this.element.shortName)) ||
            (this.element.accountNumber && super.validateCharacters(this.element.accountNumber)) ||
            (this.element.userDefinedAlias1  && super.validateCharacters(this.element.userDefinedAlias1))) {
            this.errorPop("SPECIAL_CHARACTERS_VALID");
            areValid = false;
        }
        return areValid;
    }

    validateBIC() { // BIC length 8 || 11
        return this.element.bic && this.element.bic.length !== 8 && this.element.bic.length !== 11;
    }
}
